import { useAgeGate } from '@/contexts/AgeGateContext';
import AgeGateModal from '@/components/AgeGateModal';
import Under21Page from '@/components/Under21Page';

/**
 * AgeGateWrapper - Wraps public routes with age verification
 * Shows the age gate modal if user hasn't verified
 * Shows under-21 page if user failed verification
 * Renders children if user is verified
 */
export default function AgeGateWrapper({ children }) {
  const { isVerified, isLoading, isUnder21 } = useAgeGate();

  // Show loading state while checking verification
  if (isLoading) {
    return (
      <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-zinc-950">
        <div className="flex flex-col items-center gap-4">
          <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-amber-500"></div>
          <span className="text-zinc-400 text-sm">Loading...</span>
        </div>
      </div>
    );
  }

  // Show under-21 page if user failed verification
  if (isUnder21) {
    return <Under21Page />;
  }

  // Show age gate modal if not verified
  if (!isVerified) {
    return (
      <>
        {/* Render the page content behind the modal (blurred) */}
        <div className="blur-sm pointer-events-none select-none" aria-hidden="true">
          {children}
        </div>
        {/* Age gate modal on top */}
        <AgeGateModal />
      </>
    );
  }

  // User is verified, render normally
  return children;
}
